module.exports = __webpack_public_path__ + "img/Assassins Mascot & eSports Gaming Logo p.jpg";